import {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'

type ModalSize = 'xl' | 'md' | 'sm' | 'lg'

interface Props {
  show: boolean
  size?: ModalSize
  children: React.ReactNode
  title?: string
  type?: string
  variant?: string
  centered?: boolean
  disabledSubmit?: boolean
  handleClose?: () => void
  handleSubmit?: () => void
}

const ModalComponent: FC<Props> = ({
  show,
  children,
  title,
  type = 'modal',
  variant = 'default',
  size = 'md',
  centered = false,
  disabledSubmit = false,
  handleClose,
  handleSubmit = () => {},
}) => {
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName={`modal-${size} modal-dialog-scrollable`}
      aria-hidden='true'
      onHide={handleClose}
      centered={centered}
    >
      <div className='modal-content'>
        <div className={'modal-header py-2 sdx-modal-' + variant}>
          {type === 'Alert' && (
            <div className='sdx-modal-title'>
              <p>Error!</p>
            </div>
          )}
          {type === 'modal' && <h5 className='modal-title'>{title}</h5>}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body py-2'>{children}</div>
        <div className='modal-footer py-2'>
          <div className='d-flex justify-content-center mb-3'>
            <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
              Cancelar
            </button>
            {type !== 'Alerta' && variant !== 'error' && (
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleSubmit}
                disabled={disabledSubmit}
              >
                Guardar
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalComponent}
